/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import { Icon } from '../../utils/Icon'

export type InfoButtonProps = {
  onClick: (e: any) => void
}

export const InfoButton = ({ onClick }: InfoButtonProps) => {
  return (
    <span css={rootStyle} onClick={onClick}>
      <Icon
        iconName="help_gray_map"
        style={{
          width: '24px',
          height: '24px',
        }}
      />
    </span>
  )
}

const rootStyle = css`
  display: inline-block;
  vertical-align: middle;
  z-index: 2;
  cursor: pointer;
  & > svg {
    display: block;
  }
`
